import React from 'react'
import Table from './Table'
import TableCell from './TableCell'
import AccordionTableRow from './AccordionTableRow'
import DeepTableRow from './DeepTableRow'
import GridTableRow from './GridTableRow'
import AccordionButton from './AccordionButton'
import GridButton from './GridButton'
import TableButton from './TableButton'
import EditTable from './deep-table-plugin'

function bindProps (Component, props) {
  return props2 => <Component {...props} {...props2} />
}

const TablePlugin = options => {
  const isAccordion = options.isAccordion
  const isGrid = options.isGrid
  // table is default
  const isTable = options.isTable || (!isAccordion && !isGrid)

  let typeTable = 'table'
  let typeRow = 'table_row'
  let typeCell = 'table_cell'
  let TableRow = DeepTableRow

  if (isAccordion) {
    typeTable = 'accordion_table'
    typeRow = 'accordion_table_row'
    typeCell = 'accordion_table_cell'
    TableRow = AccordionTableRow
  } else if (isGrid) {
    typeTable = 'deep_table'
    typeRow = 'deep_table_row'
    typeCell = 'deep_table_cell'
    TableRow = GridTableRow
  }

  const opts = {
    ...options,
    isAccordion,
    typeTable,
    typeRow,
    typeCell
  }

  const plugin = EditTable(opts)

  const hasTable = state => plugin.utils.isSelectionInTable(state)

  const actions = {
    onInsertTable: function (e, state) {
      e.preventDefault()
      const newState = plugin.transforms.insertTable(state.transform()).apply()
      return newState
    },

    onInsertColumn: function (e, state) {
      e.preventDefault()
      return plugin.transforms.insertColumn(state.transform())
        .apply()
    },

    onInsertRow: function (e, state) {
      e.preventDefault()
      return plugin.transforms.insertRow(state.transform())
        .apply()
    },

    onToggleHeader: function (e, state) {
      e.preventDefault()
      return plugin.transforms.toggleHeaders(state.transform())
        .apply()
    },

    onInsertAccordionRow: function (e, state) {
      e.preventDefault()
      return plugin.transforms.insertAccordionRow(state.transform())
        .apply()
    },

    onRemoveColumn: function (e, state) {
      e.preventDefault()
      return plugin.transforms.removeColumn(state.transform())
        .apply()
    },

    onRemoveRow: function (e, state) {
      e.preventDefault()
      return plugin.transforms.removeRow(state.transform())
        .apply()
    },

    onRemoveAccordionRow: function (e, state) {
      e.preventDefault()
      return plugin.transforms.removeAccordionRow(state.transform())
        .apply()
    },

    onRemoveTable: function (e, state) {
      e.preventDefault()
      return plugin.transforms.removeTable(state.transform())
        .apply()
    },

    onSetAlign: function (e, state, align) {
      e.preventDefault()
      return plugin.transforms.setColumnAlign(state.transform(), align)
        .apply()
    }
  }

  const TableSchema = {
    nodes: {
      [typeTable]: bindProps(Table, {hasTable, actions, opts}),
      [typeRow]: bindProps(TableRow, {hasTable, actions, opts}),
      [typeCell]: bindProps(TableCell, {hasTable, actions, opts})
    }
  }

  return {
    schema: { ...plugin.schema, ...TableSchema },
    onKeyDown: plugin.onKeyDown,
    AccordionButton: bindProps(AccordionButton, {hasTable, actions, isAccordion}),
    GridButton: bindProps(GridButton, {hasTable, actions}),
    TableButton: bindProps(TableButton, {hasTable, actions}),
    opts,
    isTable,
    isGrid,
    isAccordion
  }
}

export {
  TablePlugin
}



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/TableSlatePluginContainer.js